export default "__VITE_ASSET__DQgLUuIl__"